import { memo } from 'react';

/**
 * This is an issue stemming from TS not being able to "forward" free type parameters in HOCs (detailed in https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087#issuecomment-514363457).
 *
 * We aid TS with an explicit typing of React.memo (unchanged) that can be used to memoize components with generic props.
 */
export const typedMemo: <T>(c: T) => T = memo;
